import { createSvgIcon } from '@automata/mui-theme';
export const PeelIcon = createSvgIcon(
  <svg viewBox="0 0 96 96" xmlns="http://www.w3.org/2000/svg">
    <path d="M62.4744 34.9998L42.4744 34.9998V31.9998L62.4744 31.9998V34.9998Z" />
    <path d="M62.483 32.0087V52.0087H59.483V32.0087H62.483Z" />
    <path d="M58.743 33.6187L60.8643 35.74L41.0654 55.539L38.944 53.4177L58.743 33.6187Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16 54.9998L16 24.9998C16 24.4475 16.4477 23.9998 17 23.9998L81 23.9998C81.5523 23.9998 82 24.4475 82 24.9998V72.9998C82 73.552 81.5523 73.9998 81 73.9998L35 73.9998L35 76.9998L81 76.9998C83.2091 76.9998 85 75.2089 85 72.9998V24.9998C85 22.7906 83.2091 20.9998 81 20.9998L17 20.9998C14.7909 20.9998 13 22.7906 13 24.9998L13 54.9998H16Z"
    />
    <path d="M34 54.9998H13L35 76.9998L35 55.9998C35 55.4475 34.5523 54.9998 34 54.9998Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M33 56.9998L33 72.1713L17.8284 56.9998H33ZM34 54.9998C34.5523 54.9998 35 55.4475 35 55.9998L35 76.9998L13 54.9998H34Z"
    />
  </svg>,
  'PeelIcon'
);
